var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "attachments_wrapper" }, [
    _c("div", { staticClass: "scroll" }, [
      _c(
        "ul",
        { staticClass: "modal__control_file-list" },
        _vm._l(_vm.paginatedAttachmentList, function(attachment, key) {
          return _c("li", { staticClass: "modal__control_file-listitem" }, [
            _vm._v("\n        " + _vm._s(attachment.name)),
            _c("span", {
              staticClass: "modal__control_file-itemremover",
              on: {
                click: function($event) {
                  return _vm.removeAttachment(key)
                }
              }
            })
          ])
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "modal__control_file-list-control" }, [
      _c("tr", [
        _c("td", [
          this.attachmentsTotal === 1
            ? _c("span", [_vm._v(_vm._s(this.attachmentsTotal) + " Anhang")])
            : _vm._e(),
          _vm._v(" "),
          this.attachmentsTotal > 1
            ? _c("span", [_vm._v(_vm._s(this.attachmentsTotal) + " Anhänge")])
            : _vm._e()
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }